// extracted by mini-css-extract-plugin
export default {"bodyContent":"SyncFromToddleModal__bodyContent___uMS50","footerActions":"SyncFromToddleModal__footerActions___cW3yi"};